import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { getServerInfo, ServerInfoResponse } from '../../services/endpoints'

const sliceName = 'server'

export type ServerState = {
  version: string
  cpuinfo: {
    modelName: string
    processors: number
  }
  meminfo: {
    memTotal: number
    memFree: number
    memAvail: number
  }
  network: {
    name: string
    mac: string
  }[]
  extensions: ServerExtension[]
  loading?: boolean
  error?: string
}

export type ServerExtension = { 
  id: number
  val: string
  what: string
  category: string
  version: number
  enabled: boolean
}

export const serverInfo = createAsyncThunk(
  `${sliceName}/serverInfo`,
  async (_, { rejectWithValue }) => {
    try {
      return await getServerInfo()
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const initialServerState: ServerState = {
    version: '',
    cpuinfo: {
      modelName: '',
      processors: 0
    },
    meminfo: {
      memTotal: 0,
      memFree: 0,
      memAvail: 0
    },
    network: [{
      name: '',
      mac: ''
    }],
    extensions: [],
}

export const serverSlice = createSlice({
  name: sliceName,
  initialState: initialServerState,
  reducers: {
    updateServer: (state, action: PayloadAction<ServerInfoResponse>) => {
      state.version = action.payload.version,
      state.cpuinfo = action.payload.cpuinfo,
      state.meminfo =  action.payload.meminfo,
      state.network = action.payload.network,
      state.loading = false
     
      return state
    }
  },
  extraReducers(builder) {
    builder
      .addCase(serverInfo.fulfilled, (state, action: PayloadAction<ServerInfoResponse>) => {
        state.version = action.payload.version,
        state.cpuinfo = action.payload.cpuinfo,
        state.meminfo =  action.payload.meminfo,
        state.network = action.payload.network,
        state.extensions = action.payload.extensions,
        state.loading = false
     
      })
      .addCase(serverInfo.pending, (state, _action) => {
        state = {
          version: '',
          cpuinfo: {
            modelName: '',
            processors: 0
          },
          meminfo: {
            memTotal: 0,
            memFree: 0,
            memAvail: 0
          },
          network: [{
            name: '',
            mac: ''
          }],
          extensions: [],
          loading: true
      }
      })
      .addCase(serverInfo.rejected, (state, action) => {
        state = {
            version: '',
            cpuinfo: {
              modelName: '',
              processors: 0
            },
            meminfo: {
              memTotal: 0,
              memFree: 0,
              memAvail: 0
            },
            network: [{
              name: '',
              mac: ''
            }],
            extensions: [],
            loading: false,
            error: action.error.message
        }
      })
  },
})
